import React from 'react'

import HeaderTopBar from './components/HeaderTopBar/HeaderTopBar.component'
import HeaderNavBar from './components/HeaderNavBar/HeaderNavBar.component'
import HeroSection from './components/HeroSection/HeroSection.component'
import CarrierLogos from './components/CarrierLogos/CarrierLogos.component'
import NextSteps from './components/NextSteps/NextSteps.component'
import OurProducts from './components/OurProducts/OurProducts.component'
import WhyChooseUs from './components/WhyChooseUs/WhyChooseUs.component'
import HomeLogoShowcase from './components/HomeLogoShowcase/HomeLogoShowcase.component'
import TestimonialsTitle from './components/TestimonialsTitle/TestimonialsTitle.component'
import TestimonialsContent from './components/TestimonialsContent/TestimonialsContent.component'
import FooterContent from './components/FooterContent/FooterContent.component'
import FooterDisclaimer from './components/FooterDisclaimer/FooterDisclaimer.component'

import './Home.page.scss'

class HomePage extends React.Component {
  componentDidMount() {
    document.title = 'Health Insurance Agency | USA Benefits Group'
  }

  render() {
    return (
      <div id='HomePage'>
        <HeaderTopBar />
        <HeaderNavBar />
        <HeroSection />
        <CarrierLogos />
        <NextSteps />
        <OurProducts />
        <WhyChooseUs />
        {/* <HomeLogoShowcase /> */}
        <TestimonialsTitle />
        <TestimonialsContent />
        <FooterContent />
        <FooterDisclaimer />
      </div>
    )
  }
}

export default HomePage
